import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=13ef5f64&scoped=true&"
import script from "./Distributor.vue?vue&type=script&lang=js&"
export * from "./Distributor.vue?vue&type=script&lang=js&"
import style0 from "./Distributor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Distributor.vue?vue&type=style&index=1&id=13ef5f64&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef5f64",
  null
  
)

export default component.exports